module.exports = __webpack_public_path__ + "img/bs.a29a5863.svg";